export default [
  'Automobiles and Components',
  'Banks',
  'Capital Goods',
  'Commercial and Professional Services',
  'Consumer Durables and Apparel',
  'Consumer Services',
  'Diversified Financials',
  'Energy',
  'Food, Beverage, and Tobacco',
  'Food and Staples Retailing',
  'Health Care Equipment and Services',
  'Household and Personal Products',
  'Insurance',
  'Materials',
  'Media and Entertainment',
  'Pharmaceuticals, Biotechnology, and Life Sciences',
  'Real Estate',
  'Retailing',
  'Semiconductors and Semiconductor Equipment',
  'Software and Services',
  'Technology Hardware and Equipment',
  'Telecommunication Services',
  'Transportation',
  'Utilities',
];
